import { SUBSCRIPTION_INTERVAL } from "shared/enums/common.enum";

export class SubscriptionPrice {
  createdAt!: string;
  id!: string;
  interval !: SUBSCRIPTION_INTERVAL
  price: number = 0;
  stripePriceId!: string;
  subscriptionId!: string;
  updatedAt!: string;

  constructor(data?: Partial<SubscriptionPrice>) {
    Object.assign(this, data);
    if (data?.price) this.price = +data.price;
  }
}
